import React, { useState } from "react";
import { Form, Button, Spinner, Alert } from "react-bootstrap";
import { FaEnvelope, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import apiClient from "../../utils/apiClient";
import { login } from "../../utils/auth";
import useForceLightTheme from "../../hooks/useForceLightTheme";
import { useBranding } from "../../contexts/BrandingContext";
import vcLogo from "../../Assets/Images/Logos/logo.png";
import vcFavIcon from "../../Assets/Images/Logos/simple_logo.png";
import lmsLogo from "../../Assets/Images/Logos/lms_logo.png";
import lmsFavIcon from "../../Assets/Images/Logos/lms_logo.png";
import "./TenantAdminLogin.scss";

const isLmsCampus = () => {
  const h = window.location.hostname;
  return h.endsWith('lmscampus.com') || h === 'localhost';
};
const logo = isLmsCampus() ? lmsLogo : vcLogo;
const favIcon = isLmsCampus() ? lmsFavIcon : vcFavIcon;

const TenantAdminLogin = () => {
  useForceLightTheme();
  const branding = useBranding();
  const brandLogo = branding.logoUrl || logo;
  const brandFavIcon = branding.faviconUrl || branding.logoUrl || favIcon;
  const brandName = branding.brandName;

  const [creds, setCreds] = useState({ phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setCreds((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await apiClient.post("/auth/login", {
        ...creds,
        usertype: "tenantadmin",
      });
      if (data.token) {
        login(data);
        navigate("/sa");
      } else {
        setError("Invalid response from server.");
      }
    } catch (err) {
      setError(err?.response?.data?.message || "Login failed!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ta-login-page">
      <div className="ta-login-card">
        <div className="ta-login-header">
          <img src={brandFavIcon} alt="Logo" className="ta-login-logo" />
          <h1 className="ta-login-title">{brandName}</h1>
          <span className="ta-login-badge">Platform Administration</span>
          <p className="ta-login-subtitle">
            Sign in to the tenant management console
          </p>
        </div>

        <Form onSubmit={handleSubmit} className="ta-login-form">
          <div className="ta-input-group">
            <label>Phone Number</label>
            <div className="ta-input-wrapper">
              <FaEnvelope className="ta-input-icon" />
              <input
                type="text"
                placeholder="Enter your phone number"
                name="phone"
                autoComplete="username"
                value={creds.phone}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="ta-input-group">
            <label>Password</label>
            <div className="ta-input-wrapper">
              <FaLock className="ta-input-icon" />
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                name="password"
                autoComplete="current-password"
                value={creds.password}
                onChange={handleChange}
                required
              />
              <button
                type="button"
                className="ta-password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                tabIndex={-1}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          {error && (
            <Alert variant="danger" className="ta-alert">
              {error}
            </Alert>
          )}

          <Button type="submit" className="ta-submit-btn" disabled={loading}>
            {loading ? (
              <Spinner size="sm" animation="border" />
            ) : (
              "Sign In"
            )}
          </Button>
        </Form>

        <div className="ta-login-footer">
          <img src={brandLogo} alt={brandName} />
        </div>
      </div>
    </div>
  );
};

export default TenantAdminLogin;
